import { AdminBarberRepository } from "../../Repository";

export async function changeBreakTime(
  startTime: string,
  endTime: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.setBreakTime(startTime, endTime);
}
